const HEADERS = {
  "TYPE": "Content-Type",
  "TEXT": "text/plain",
  "APPLICATION": "application/json",
  "ACCEPT": "Accept",
  "CACHE": "Cache-Control",
  "NO_CACHE": "no-cache",
  "ALLOW_ORIGINS": "Access-Control-Allow-Origin",
  "ALLOW_METHODS": "Access-Control-Allow-Methods",
  "AUTH": "Authorization"
};

export default HEADERS;
